import { LaunchDarklyUserInfo } from './buildLaunchDarklyContext';
import { getAdminLaunchDarklyUserInfo } from './getAdminLaunchDarklyUserInfo';
import { isAuthenticatedAdminRoute } from './isAuthenticatedAdminRoute';

type ResolveLaunchDarklySessionParams = {
  pathname: string;
  userAmsUserId?: string;
  marketerSessionUserInfo: LaunchDarklyUserInfo | null;
  selectedOrganizationId?: string;
};

export const resolveLaunchDarklySession = ({
  pathname,
  userAmsUserId,
  marketerSessionUserInfo,
  selectedOrganizationId,
}: ResolveLaunchDarklySessionParams): {
  userInfo: LaunchDarklyUserInfo | null;
  organizationId?: string;
} => {
  if (isAuthenticatedAdminRoute(pathname)) {
    return {
      userInfo: getAdminLaunchDarklyUserInfo(),
    };
  }

  if (userAmsUserId) {
    return {
      userInfo: marketerSessionUserInfo ?? {
        ams_user_id: userAmsUserId,
      },
      organizationId: selectedOrganizationId,
    };
  }

  return {
    userInfo: getAdminLaunchDarklyUserInfo(),
    organizationId: selectedOrganizationId,
  };
};
